import {ShippingData} from "@/types/shippingData";
import axios from "axios";
import {Quantities} from "@/types/quantities";

export interface DeliveryPeriod {
  start: string;
  end: string;
}

export interface DeliveryPeriodResponse {
  delivery_period: DeliveryPeriod;
}

export const getShippingData = async (quantities: Quantities, country: string): Promise<ShippingData> => {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')

    let csrfTokenStr = ""

    if (csrfToken) {
        csrfTokenStr = csrfToken.getAttribute('content') ?? ""
    }

    if (csrfTokenStr !== "") {
        axios.defaults.headers.common = {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': csrfTokenStr
        };
    }

    const calculation = await axios.post('/api/v2/shipping-costs', {
        quantities: quantities,
        country: country
    });

    return calculation.data;
}

export const getCartDeliveryPeriod = async (quantities: Quantities, country: string): Promise<DeliveryPeriodResponse> => {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')

    let csrfTokenStr = ""

    if (csrfToken) {
        csrfTokenStr = csrfToken.getAttribute('content') ?? ""
    }

    if (csrfTokenStr !== "") {
        axios.defaults.headers.common = {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': csrfTokenStr
        };
    }

    // Convert quantities to items array format
    const items = Object.entries(quantities)
        .filter(([sku, quantity]) => quantity > 0)
        .map(([sku, quantity]) => ({ product_sku: sku, quantity }));

    const response = await axios.post('/api/v2/delivery-estimates/cart', {
        country: country,
        items: items
    });

    return response.data;
}
